// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2nVW5","consentsList":"PatientConsents_consentsList__l7y-x","consentsListEmpty":"PatientConsents_consentsListEmpty__3ZLB7"};